import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRanking() {
  const ranked = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              <i className="ri-fire-line text-primary-500 mr-2"></i>
              热门排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">根据阅读量实时更新的热门韩漫</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4">
          {ranked.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2.5">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 汗汗漫画热门推荐`}
                  title={`${comic.title} - 汗汗漫画排行第${index + 1}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-0 left-0 w-7 h-7 bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold rounded-br-lg">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xs font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {comic.title}
              </h3>
              <div className="flex items-center gap-1 mt-1">
                <i className="ri-eye-line text-[10px] text-foreground-400"></i>
                <span className="text-[10px] text-foreground-400">
                  {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}